import React from 'react';

type Props = {
    className?  : string

    scale       : number
    value       : number

    showEmpty?  : boolean
}

export default function UI5Rating(props:Props) {
    const stars = new Array(props.scale).fill(true).fill(false, props.value);

    const classes = Classes("ui5-selector-rating", props.className, {
        'show-empty': props.showEmpty,
        'is-empty'  : !props.value
    })

    return (
        <div className={classes}>
            {_.map(stars, (value, key)=>{
                const classes = Classes("icon", {
                    'filled i5-star'       : value,
                    'empty i5-star-empty'  : !value,
                })
                return <div key={key} className={classes}/>
            })}
        </div>
    )
}
